import { Navigate, useParams } from 'react-router-dom'

interface RedirectToSheetProps {
  base: string
  param: string
}

/**
 * Composant utilitaire qui redirige une route legacy (`/licences/:skuId`,
 * `/licences-utilisateurs/:objectId`) vers la liste parente avec ouverture
 * automatique du Sheet via querystring.
 *
 * Spec 046 — FR-019 : préserve les liens existants (favoris, commentaires,
 * emails partagés) sans casser l'URL.
 *
 * Exemple :
 *   <Route path="/licences/:skuId" element={<RedirectToSheet base="/licences" param="sku" />} />
 *   <Route path="/licences-utilisateurs/:objectId" element={<RedirectToSheet base="/licences-utilisateurs" param="user" />} />
 */
export function RedirectToSheet({ base, param }: RedirectToSheetProps) {
  const params = useParams()
  // Extrait le 1er paramètre dynamique nommé (skuId, objectId, etc.) en EXCLUANT le splat `*`.
  // Le parent route utilise `path="/*"` ce qui ajoute `params['*']` = chemin restant — sans
  // ce filtre on tomberait sur la valeur du splat (ex. "licences/abc-123") au lieu du paramètre
  // réel ("abc-123") et l'URL de destination serait corrompue.
  const id = Object.entries(params).find(([key, value]) => key !== '*' && Boolean(value))?.[1] ?? ''
  const target = id ? `${base}?${param}=${encodeURIComponent(id)}` : base
  return <Navigate to={target} replace />
}
